export default "__VITE_ASSET__B0zgDKyr__"